import { connect } from "react-redux"
import moment from "moment"
import _ from "lodash"
import routeNames from "components/navigators/constants"
import {
  calendarDateSelected,
  startTimeSelected,
} from "modules/Seller/CreateOffer/actions"
import View from "./view"
import { Store } from "utilities/Redux/store"
import { Navigation } from "components/types"
import { DateObject } from "react-native-calendars"
import { getTempOffer } from "modules/Seller/CreateOffer/selectors"
import { getSelectedOfferRequestForSeller } from "modules/Seller/OfferRequests/selectors"
import { OfferRequestDateQuestion } from "database_types/offerRequestQuestions"

interface OwnProps {
  navigation: Navigation
}

const mapStateToProps = (state: Store) => {
  const offerRequest = getSelectedOfferRequestForSeller(state)
  if (!offerRequest) {
    return {}
  }

  const questions = Object.values(offerRequest.questions)
  let dateQuestionValue: OfferRequestDateQuestion | undefined
  questions.forEach(question => {
    if (question.type === "date") {
      dateQuestionValue = question
    }
  })
  const offer = getTempOffer(state, offerRequest.id)
  return {
    offerRequest,
    dateQuestion: dateQuestionValue,
    offer,
  }
}

const mapDispatchToProps = {
  calendarDateSelected,
  startTimeSelected,
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
  ownProps: OwnProps,
) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  openTimetable: (day: DateObject) => {
    if (!stateProps.dateQuestion || !stateProps.dateQuestion.suitableTimes) {
      return
    }
    const suitableTimes = stateProps.dateQuestion.suitableTimes
    const suitableDates = _.uniq(_.map(suitableTimes, "day"))
    const isDaySuitable = suitableDates.includes(day.dateString)
    if (isDaySuitable) {
      // Reset selected start time
      dispatchProps.startTimeSelected(null)
      dispatchProps.calendarDateSelected(day.dateString)
      ownProps.navigation.navigate(routeNames.SELLER.CREATE_OFFER_TIMETABLE, {
        name: moment(day.dateString).format("dddd D.M."),
      })
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(View)
